<script setup lang="ts">
import StatCard from '@/components/ui/StatCard.vue';

defineProps<{
  avgDays: number | null;
  loading?: boolean;
}>();
</script>

<template>
  <div data-testid="resolution-time-stat">
    <StatCard
      label="Avg. resolution"
      :value="loading || avgDays === null ? '—' : `${avgDays}d`"
      sub="Average days to close"
    />
  </div>
</template>
